module.exports = __webpack_public_path__ + "img/icon-information.4daa2f04.png";